import Head from "next/head";
import DynamicComp from "../components/DynamicComp";
import Layout from "../components/Layout";
import { fetcher } from "../helper/fetcher";
import {
  isAppWebView as checkAppWebView,
  getAppDeviceType,
} from "../helper/isAppWebView";

export async function getServerSideProps(context) {
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 1 gün
  const expires = `expires=${date.toGMTString()}`;

  const slug = context?.query?.slug;
  const cu = context.query;
  delete cu.slug;
  let disableHeader = false;

  // React Native App için WebView kontrolü yapıyoruz
  const isAppWebView = checkAppWebView(context);
  const deviceType = getAppDeviceType(context);

  if (slug == "size-ozel-villa") {
    const Method = context.req.method;

    // Eğer referer varsa ve belirli bir domainden geliyorsa
    if (Method == "POST" || context?.req?.cookies["user-link"]) {
      if (context?.query?.ids) {
        disableHeader = true;
        // React Native App WebView'den geliyorsa çerez set etme
        if (
          context?.req?.cookies["user-link"]?.length == undefined &&
          !isAppWebView
        ) {
          context.res.setHeader("Set-Cookie", [
            `ids=${context.query.ids}; Path=/; Expires=${expires}`,
            `user-link=1; Path=/; Expires=${expires}`,
          ]);
        }
      }
    } else {
      return {
        redirect: {
          destination: "/",
          statusCode: 301,
        },
      };
    }
  }

  const str = Object.keys(cu)
    .map((key) => key + "=" + cu[key])
    .join("&");

  const repoInfo = await fetcher(
    process.env.NEXT_PUBLIC_API +
      "/Routing?user-link=" +
      context?.req?.cookies["user-link"] +
      "&url=" +
      context.params.slug.join("/") +
      (str ? "&" + str : ""),
  );
  const headerContent = await fetcher(
    process.env.NEXT_PUBLIC_API + "/FullScreenMenu",
  );
  repoInfo.headerContent = headerContent;

  if (
    context?.req?.cookies["user-link"] == "1" &&
    repoInfo?.RoutingTypeId == "ProductDetail"
  ) {
    if (
      ("," + context?.req?.cookies["ids"] + ",").indexOf(
        "," + repoInfo?.EntityId + ",",
      ) > -1
    ) {
      disableHeader = true;
    }
  }

  if (
    context?.req?.cookies["user-link"] == "1" &&
    repoInfo?.RoutingTypeId == "Reservation"
  ) {
    if (
      ("," + context?.req?.cookies["ids"] + ",").indexOf(
        "," + repoInfo?.result?.Product?.id + ",",
      ) > -1
    ) {
      disableHeader = true;
    }
  }

  if (disableHeader) {
    repoInfo.disableHeader = true;
    repoInfo.disableFooter = true;
  }

  if (repoInfo.error) {
    return {
      redirect: {
        destination: "/",
        statusCode: 301,
      },
    };
  }

  if (repoInfo.redirect)
    return {
      redirect: {
        destination: repoInfo.redirect.yeni_link,
        statusCode: parseInt(repoInfo.redirect.turu_code),
      },
    };

  return {
    props: {
      data: repoInfo,
      index: context.query.search ? context.query.search : "",
      isAppWebView,
      deviceType,
    },
  };
}
export default function Meta({ data, index, isAppWebView, deviceType }) {
  return (
    <Page
      fallback={data}
      index={index}
      isAppWebView={isAppWebView}
      deviceType={deviceType}
    />
  );
}

const Page = ({ fallback, index, isAppWebView, deviceType }) => {
  const data = fallback;
  return (
    <>
      <Head>
        <title>{data.result.title}</title>
        <meta name="description" content={data.result.description}></meta>
        <meta name="keywords" content={data.result.keywords}></meta>
        <meta name="author" content={process.env.NEXT_PUBLIC_DOMAIN}></meta>
        <meta name="publisher" content={process.env.NEXT_PUBLIC_DOMAIN}></meta>
        {process.env.NEXT_PUBLIC_SITE == 3 ? (
          <link rel="icon" href="/favicon2.ico" />
        ) : (
          <link rel="icon" href="/favicon.ico" />
        )}

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <link rel="canonical" href={data.result.canonical} />
        {index ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <meta name="robots" content="index, follow" />
        )}
        {data?.result && (
          <>
            <meta property="og:url" content={data.result.canonical} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={data.result.title} />
            <meta property="og:description" content={data.result.description} />
            <meta
              property="og:image"
              content={
                process.env.NEXT_PUBLIC_CDN + "/uploads/" + data.result.resim
              }
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta
              property="twitter:domain"
              content={process.env.NEXT_PUBLIC_DOMAIN}
            />
            <meta property="twitter:url" content={data.result.canonical} />
            <meta name="twitter:title" content={data.result.title} />
            <meta
              name="twitter:description"
              content={data.result.description}
            />
            <meta
              name="twitter:image"
              content={
                process.env.NEXT_PUBLIC_CDN + "/uploads/" + data.result.resim
              }
            />
          </>
        )}
      </Head>
      <Layout ssr={data} isAppWebView={isAppWebView} deviceType={deviceType}>
        <DynamicComp
          ssr={data}
          page={data.result}
          action={data.RoutingAction}
          RoutingController={data.RoutingController}
          isAppWebView={isAppWebView}
          deviceType={deviceType}
        />
      </Layout>
    </>
  );
};
